import styled from 'styled-components';

import { MpText } from 'shared/ui/MpText';

export const RequestConsultationStyled = styled.div``;

export const RequestConsultationHeaderStyled = styled.h2`
	margin-bottom: 16px;
`;

export const RequestConsultationTextStyled = styled(MpText)`
	margin-bottom: 25px;
`;

export const InputContainerStyled = styled.div`
	margin-bottom: 25px;
`;
